import { EventEmitter } from 'events';

export const eventBus = new EventEmitter();
eventBus.setMaxListeners(0);

export enum LoginEvent {
  JoinMeeting = 'JoinMeeting',
}

export enum ViewBoxEvent {
  Play = 'Play',
  PlayFast = 'PlayFast',
  SDOMCREATE = 'sdomcreate', // sdom初始化完成
}
